// Angebot → Auftrag: the draft OrderModal opens with. Prices are dropped and only hour
// positions carry a quantity; mirrors routes/offers/control.py, so change both or neither.

import { nextOrderNumber } from './documentNumber';

// Hour units. `unit` is the free text the position editor lets the user type;
// `unit_code` is the UN/ECE code (HUR = hour) and only a fallback — see `isHourLine`.
const HOUR_UNIT_CODE = 'HUR';
const HOUR_UNITS = ['h', 'H', 'Std', 'Std.', 'Stunde', 'Stunden'];

/** Does this position bill hours? The free-text `unit` decides and `unit_code` only where none
 *  was entered: `InvoiceModal` hardcodes `'HUR'` and never re-derives it. */
export function isHourLine(line) {
    const unit = String(line?.unit ?? '').trim();
    if (unit !== '') return HOUR_UNITS.includes(unit);
    return String(line?.unit_code ?? '').trim().toUpperCase() === HOUR_UNIT_CODE;
}

/** One offer position → one order position (ticket assigned later, in the modal). */
export function offerLineToOrderLine(line) {
    // Both texts trimmed, blanks dropped. Has to come out byte-identical to the backend's
    // `_order_item_description`.
    const description = [line?.description, line?.sub_description]
        .map(text => String(text ?? '').trim())
        .filter(text => text !== '')
        .join('\n');
    return {
        ticket_id: null,
        ticket_name: '',
        description,
        hours: isHourLine(line) ? Number(line?.quantity) || 0 : 0,
    };
}

const roundHours = (hours) => Math.round(hours * 100) / 100;

/** All positions of an offer, in the stored order — never sorted. */
export function offerLinesToOrderLines(lines) {
    return (Array.isArray(lines) ? lines : []).map(offerLineToOrderLine);
}

/** Local ISO date (yyyy-mm-dd) — toISOString() would drift a day around midnight. */
function todayIso() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** The OrderModal form draft for an accepted offer; *allOrders* supplies the next number. */
export function offerToOrderDraft(offer, allOrders = []) {
    const lineItems = offerLinesToOrderLines(offer?.line_items);
    return {
        order_number: nextOrderNumber(allOrders),
        title:        `Angebot ${offer?.offer_number ?? ''}`.trim(),
        project_id:   '',
        company_id:   offer?.company_id ? String(offer.company_id) : '',
        status:       'active',
        issue_date:   todayIso(),
        due_date:     '',
        start_date:   '',
        end_date:     '',
        // Rounded like the backend's round(sum, 2): float addition of 0.1 + 0.2 must not
        // reach the Auftrag as 0.30000000000000004 from one side and 0.3 from the other.
        total_hours:  roundHours(lineItems.reduce((sum, li) => sum + li.hours, 0)),
        notes:        offer?.notes || '',
        line_items:   lineItems,
    };
}
